export default __webpack_public_path__ + "75f1556a10a5661bb92051bf30428ad6.svg";